<template>
  <b-modal :active.sync="isBulkExportModal" has-modal-card>
    <div class="modal-card">
      <header class="modal-card-head">
        <h1 class="is-title-header modal-card-title">
          Date Range For Downloading Reporting Tracker Data
        </h1>
      </header>
      <section class="modal-card-body">
        <div class="columns">
          <div class="column">
            <b-field label="Date Type">
              <b-select
                name="date_type"
                v-model="date_type"
                expanded
                placeholder="Please select"
                required
                data-cy="date-type"
              >
                <option value="scheme_deadline">Scheme Deadline</option>
                <option value="actual_submission_deadline"
                  >Actual Submission Date</option
                >
              </b-select>
            </b-field>

            <b-field label="Starting Date">
              <b-datepicker
                name="start_from"
                v-model="start_from_date"
                required
                icon="calendar-today"
                trap-focus
                v-on:input="selectableDates"
                data-cy="starting-date"
                :date-formatter="dateFormatter"
              >
              </b-datepicker>
            </b-field>
            <b-field label="Ending Date">
              <b-datepicker
                name="end_to"
                v-model="end_to_date"
                :min-date="minDate"
                required
                icon="calendar-today"
                trap-focus
                data-cy="ending-date"
                :date-formatter="dateFormatter"
              >
              </b-datepicker>
            </b-field>
            <b-field label="Customers">
              <b-select
                multiple
                placeholder="Select customers"
                v-model="selectedCustomers"
                expanded
                data-cy="customers"
              >
                <option
                  v-for="(option, index) in customers"
                  :value="option.id"
                  :key="index"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
          </div>
        </div>
      </section>

      <footer class="modal-card-foot">
        <b-button
          slot="right"
          native-type="submit"
          type="is-primary"
          v-on:click="submit"
        >
          Export
        </b-button>
        <b-button slot="right" type="is-danger" @click="cancel">
          Abort
        </b-button>
      </footer>
    </div>
  </b-modal>
</template>
<script>
import ReportingTrackerDataService from "../../services/ReportingTrackerDataService";
import CustomerProfileDataService from "../../services/CustomerProfileDataService";
//import ScopeMixin from "@/mixins/scopeMixin";
export default {
  //mixins: [ScopeMixin],
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    customers: {}
  },
  data() {
    const today = new Date();
    return {
      customerDataService: new CustomerProfileDataService(),
      start_from_date: null,
      end_to_date: null,
      date_type: null,
      selectedCustomers: [],
      minDate: new Date(
        today.getFullYear() - 100,
        today.getMonth(),
        today.getDate()
      ),
      isBulkExportModal: false,
      reportingTrackerService: new ReportingTrackerDataService()
    };
  },
  mounted() {
    // this.fetchCustomerProfileData();
  },
  methods: {
    handleApiError(reason) {
      console.log(reason.response.data);
    },
    dateFormatter(dt) {
      if (dt != null) {
        return dt.toLocaleDateString("fr-CA");
      }
      return dt;
    },
    selectableDates() {
      this.minDate = this.start_from_date;
    },
    submit() {
      try {
        if (this.selectedCustomers.length == 0) {
          throw "No User Selected";
        }
        this.reportingTrackerService.exportBulkReport(
          this.date_type,
          this.start_from_date,
          this.end_to_date,
          this.selectedCustomers
        );
        this.$emit("confirm");

        this.start_from_date = null;
        this.end_to_date = null;
      } catch (e) {
        if (e == "No User Selected") {
          this.$buefy.dialog.alert({
            title: "No Customers Selected",
            message: "At least one Customer must be selected"
          });
        } else {
          this.$buefy.dialog.alert({
            title: "Error in Export",
            message: e.message
          });
        }
      }
    },
    cancel() {
      (this.start_from_date = null),
        (this.end_to_date = null),
        this.$emit("cancel");
    }
  },
  watch: {
    isActive(newValue) {
      this.isBulkExportModal = newValue;
    },
    isBulkExportModal(newValue) {
      if (!newValue) {
        this.$emit("cancel");
      }
    }
  }
};
</script>
